import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import * as TicketLabel from './TicketLabel';

export type BaseView = {
  '@id': string;
  '@type': 'Company';
  id: string;
  slug: string;
  name: string;
  retainer: number | null;
  maintenanceHoursMonthly: number | null;
  maintenanceHoursWeekly: number | null;
  archivedAt: string | null;
  backgroundColor: string | null;
  websiteUrl: string | null;
  betterUptimeStatusPageId: string | null;
  featureBi: boolean | null;
  featureBiRealtime: boolean;
};

export type V_AdminList = BaseView & {
  slaInitialReply: boolean;
  ticketLabels: Array<TicketLabel.BaseView>;
};

export function useReadCollection(options?: ReadConfig) {
  return useApiRead<HydraCollection<V_AdminList>>(`/companies`, options);
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<BaseView>(`/companies/${id}`, options);
}
